// extracted by mini-css-extract-plugin
export var container = "CompanyInfo-module--container--3CQP0";
export var infoTitle = "CompanyInfo-module--infoTitle--u2uNy";